import axiosInstance from "../config/axiosInstance";

export const downloadFileChunk = async (
  blobFileName: string,
  chunkIndex: number,
  requestFrom: number = 1 // Default to 1 if not provided
) => {
  try {
    const response = await axiosInstance.get(`/api/getFilePreview`, {
      params: {
        blob_file_name: blobFileName,
        start: chunkIndex,
        request_from: requestFrom,
      },
      responseType: "blob", // Ensure the response is treated as a blob
    });
    return response;
  } catch (error) {
    console.error("Error downloading file chunk:", error);
    throw new Error("Failed to download file chunk");
  }
};
